import Comps from '@owenscorning/react-library';
import React from 'react';
import { connect } from 'react-redux';

import { hideErrorModal } from '../WarrantyStandardForm/redux/actions';

const { Modal } = Comps.Connect;

const ErrorModal = ({ showErrorModal, hideErrorModal }) => (
  <Modal open={showErrorModal} onClose={hideErrorModal}>
    <h2>An error has occured</h2>
    <p>Please try again later or contact us at 1-800-ROOFING.</p>
    <a
      data-track="form-modal-back"
      data-track-form-name="Warranty Form"
      data-track-form-step="error modal"
      href="/roofing/warranty"
      className="cta"
    >
      Back to Warranties Page
    </a>
  </Modal>
);

const mapStateToProps = state => ({
  showErrorModal: state.showErrorModal,
});
const mapDispatchToProps = dispatch => ({
  hideErrorModal: () => dispatch(hideErrorModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
